import { Stream } from '@cloudflare/stream-react'
import {ReactComponent as PlayIcon} from '@assets/img/icons/play.svg';
import {ReactComponent as ArrowRightIcon} from '@assets/img/icons/arrow-right.svg';
import {ReactComponent as PictureIcon} from '@assets/img/icons/picture.svg';

const Image = ({title, featured_media: {media}}) => {
  return (
    <img src={media} className="absolute w-full" alt={title} />
  )
}

const Video = ({featured_media}) => {
  const media = JSON.parse(featured_media.media);
    // console.log(media);
    return (
        <Stream controls src={media.uid} poster={media.thumbnail} />
    )
}


const Content = (details) => {
  return (
    <div className='overflow-hidden rounded-2xl mb-4 relative'>
      {
        {
          'image': <Image {...details} />,
          'video': <Video {...details} />
        }[details.featured_media.type] || 
          <>Content appears to be broken!</>
      }
        <div className="absolute px-2.5 bottom-3.5 w-full">
          <div className='flex w-full bg-gradient-to-br from-white/60 rounded-2xl p-4 backdrop-blur-lg shadow-lg'>
            <div className="leading-5 flex-1 pr-4">
              <p className='font-medium'>{details.title}</p>
              <span className='text-[10px] tracking-wider uppercase text-[#e2e0e0]'>{details.featured_media.type}</span>
            </div>

            <span className='bg-white w-8 h-8 rounded-2xl'>
              {
                {
                  'image': <PictureIcon className='w-8 h-8 fill-primary' />,
                  'video': <PlayIcon className='w-8 h-8 fill-primary' />
                }[details.featured_media.type] || <ArrowRightIcon className='w-8 h-8 fill-primary' />
              }
            </span>
          </div>
        </div>
    </div>
  )
}

export default Content